import {Injectable} from '@angular/core'
import {Query} from 'apollo-angular'
import gql from 'graphql-tag'
import {OrderDetail} from '../../../../api/graphql'

interface Response {
    getOrderDetails: OrderDetail[]
}

@Injectable({
    providedIn: 'root'
})
export class GetOrderDetailsQuery extends Query<Response> {
    document = gql`
        query {
            getOrderDetails {
                additionalPrice
                createdAt
                food {
                    category {
                        description
                        id
                        name
                        registeredAt
                    }
                    description
                    id
                    name
                    price
                    registeredAt
                    type
                }
                history {
                    date
                    id
                    status
                    user {
                        id
                        names
                    }
                }
                id
                observations
                quantity
                status
            }
        }
    `
}
